export default __webpack_public_path__ + "static/media/stormblood.7fc0e11c.png";